import { useMemo } from 'react'

import { getUserAgnosticGlobalFeatureGatesFromMemory } from '@src/modules/global-state/user-agnostic-feature-gates.browser'

import Product, { ProductLite } from '../domains/Product'
import Bundle from '../domains/Product/BundleProduct'
import ProductTag from '../domains/ProductTag'
import { ProductVariantOption } from '../domains/ProductVariant'
import productHelper from '../helpers/productHelper'

export const useProductCardTags = ({
  product,
  productTags,
  selectedOptions,
}: {
  product: Product | ProductLite | Bundle
  productTags: ProductTag[]
  selectedOptions: ProductVariantOption[]
}): { applicableTags: ProductTag[]; getItBy24: boolean } => {
  const { applicableTags, getItBy24 } = useMemo(() => {
    const allTags = productHelper.getApplicableTags({
      product,
      productTags,
      selectedOptions,
    })
    const enableEarnCreditTags = getUserAgnosticGlobalFeatureGatesFromMemory().credit_tags_on_product_card
    const getItBy24 = false
    let isOutOfStock = false

    const applicableTags = allTags
      .filter(item => {
        switch (item.value) {
          // hide valentine tag
          case 'GET IT BY 02/14':
            return false
          case 'Today Only':
            return false
          case 'Sold Out':
            isOutOfStock = true
            return true
          default:
            return true
        }
      })
      .filter(item => {
        const isEarnTag = item.value.includes('Earn $')
        const isThirdPartySeller = item?.vendor_type === '3P'
        const creditTagsAreOff = !enableEarnCreditTags

        // Only remove the "Earn $" tag if it's from a 3P seller and credit tags are off
        if (creditTagsAreOff && isEarnTag && isThirdPartySeller) {
          return false // exclude
        }

        return true // show the tags
      })
    return {
      applicableTags,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      getItBy24: getItBy24 && !isOutOfStock,
    }
  }, [selectedOptions, productTags, product])

  return { applicableTags, getItBy24 }
}
